import React from "react";

// Pure — the status colour legend row. `leading` slots the embedded month picker (embedded
// mode); `trailing` slots the flag button, which always sits after the last status.
export const StatusLegend = ({ statuses, leading = null, trailing = null }) => (
    <div className="stv2-tracker-status-legend">
        {leading}
        {statuses.map((status, i) => (
            <div className="stv2-tracker-status-legend-container" key={`stv2-tracker-status-legend-${i}`}>
                <div style={{ width: 20, height: 20, backgroundColor: status.color }}></div>
                <div style={{ marginLeft: 10 }}>{status.name}</div>
            </div>
        ))}
        {trailing}
    </div>
);
